import React from 'react';
import { Section, Content, Main } from './../../../components/includes/container';
import { withStyles } from './../../../themes/default';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { LogService } from './../../../services';
import { Table, Thead, Tbody, Row, Cell, Tresponsive, Ttolbar } from './../../../components/includes/ui/table';
import { Loading } from './../../../components/includes/loading';
import { Label } from './../../../components/includes/ui';
import { FormatDate } from './../../../utilities/date';
import { isSorting } from './../../../utilities/utils';
import { SelectField, OptionField } from './../../../components/includes/ui/input';
import { reduxForm, Field } from 'redux-form';

const rows = [
  { id: 'date', sort: false, numeric: false, disablePadding: false, label: 'Fecha' },
  { id: 'filename', sort: false, numeric: false, disablePadding: false, label: 'Archivo' },
  { id: 'type', sort: false, numeric: false, disablePadding: false, label: 'Tipo' },
  { id: 'message', sort: false, numeric: false, disablePadding: false, label: 'Mensaje' }
];

const styles = theme => ({
  log: {
    whiteSpace: 'pre-line'
  }
});

class Logs extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      order: 'desc',
      orderBy: 'date',
      log: null,
      filename: null,
      filenames: null
    };
  }

  componentDidMount(){
    this._FindFilenames();
    this._Find();
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.filename !== this.state.filename) {
      this._Find();
    }
  }

  /*
  ** @Service
  ** @Description: Find log
  */

  _Find = (_filename = '') => {
    let filename = !_filename ? this.state.filename: _filename;
    if(filename) {
      LogService.get(filename).then((response) => {
        this.setState({ loading: true, log: response.log });
      }).catch((error) => {
        console.log('Error: ', error);
      });
    }
  }

  _FindFilenames = async () => { 
    try {
      const { filenames } = await LogService.getFilenames();
      this.setState({ filename: filenames[0], filenames });
    } catch(err) {
      console.log('Error: ', err)
    }
  }

  handleChangeForm = (e, value) => {
    let _value = value !== '-1'  ? value : this.state.filename;
    this._Find(_value);
  }
  renderOption = (filename, listnames) => {
    let filenames = listnames.filter( file => file !== filename);
    return filenames.map(file => <OptionField key={file} value={file}>{file}</OptionField>)
  }

  render() {
    const { loading, order, orderBy, log, filenames, filename } = this.state;
    return (
        <Section>
          <ToolbarPrimary title="Logs"/>
          <BreadcrumbItem to='/logs'>Logs</BreadcrumbItem>
          <Content>
            <Main>
              <form noValidate autoComplete="off">
              <Ttolbar title="Logs">
                {filename && filenames &&
                  <div style={{width: '150px', marginBottom: '5px'}}>
                    <Field
                      name="filename"
                      component={ SelectField }
                      onChange={this.handleChangeForm}
                      label="Archivo">
                        <OptionField key="-1" value="-1">{filename}</OptionField>
                        {this.renderOption(filename, filenames)}
                    </Field>
                  </div>}
                </Ttolbar>
              </form>
              { loading ? (
                <Tresponsive>
                  <Table>
                  <Thead rows={ rows } order={ order } orderBy={ orderBy } onRequestSort={ this.handleRequestSort }/>
                    <Tbody>
                      {
                        log ?
                          (log.sort(isSorting(order, orderBy)).map(({date, filename, type, message}) => {
                            return (
                              <Row key={ date }>
                                <Cell><FormatDate value={ date }/></Cell>
                                <Cell>{ filename }</Cell>
                                <Cell>
                                  <Label variant="info">
                                    { type }
                                  </Label>
                                </Cell>
                                <Cell>
                                  <span dangerouslySetInnerHTML={{ __html: message }}/>
                                </Cell>
                              </Row>
                            )
                          })) : (
                            <Row key="1">
                              <Cell colSpan={ rows.length }>No se encontraron resultados.</Cell>
                            </Row>
                          )
                      }
                    </Tbody>
                  </Table>
                </Tresponsive>
              ) : (
                <Loading variant="primary"/>
              ) }
            </Main>
          </Content>
        </Section>
      )
    }

}

Logs = reduxForm({
  form: 'Logs',
  initialValues: {
    filename: '-1'
  }
})(Logs);

export default withStyles(styles)(Logs);
